(function(app, ng) {
    editHouseholdRelationshipController.$inject = ["genders", "prefixes", "_states", "suffixes", "physicalAddressTypes",
        "phoneNumberTypes", "emailAddressTypes", "$mdDialog", "_householdRelationshipTypes", "clientApi", "personApi", "householdRelationshipApi"]; 
    app.controller("editHouseholdRelationshipController", editHouseholdRelationshipController);

    function editHouseholdRelationshipController(genders, prefixes, states, suffixes, physicalAddressTypes, phoneNumberTypes,
        emailAddressTypes, $mdDialog, householdRelationshipTypes, clientApi, personApi, householdRelationshipApi) {
        var $ctrl = this;

        $ctrl.relationship.TargetClient.Person.Dob =
            new Date($ctrl.relationship.TargetClient.Person.Dob);

        $ctrl.client = $ctrl.relationship.TargetClient;

        ng.extend($ctrl,
        {
            genders: genders,
            prefixes: prefixes,
            states: states,
            suffixes: suffixes,
            physicalAddressTypes: physicalAddressTypes,
            phoneNumberTypes: phoneNumberTypes,
            emailAddressTypes: emailAddressTypes,
            householdRelationshipTypes: householdRelationshipTypes,
            close: close,
            saveRelationship: saveRelationship,
            updateClient: updateClient,
            updatePerson: updatePerson, 
            updateRelationshipType: updateRelationshipType, 
            updateContact: updateContact
        });

        function close() {
            return $mdDialog.hide();
        }

        function updateClient() {
            return clientApi.update($ctrl.relationship.TargetClient).then(function () {
            });
        }

        function updatePerson() {
            return personApi.update($ctrl.relationship.TargetClient.Person)
                .then(function () {
                });
        }

        function updateRelationshipType() {
            return householdRelationshipApi.updateType($ctrl.relationship)
                .then(function (rel) {
                    $ctrl.relationship.TypeName = rel.Type;
                });
        }
    }
})(window.app, window.angular); // jshint ignore:line